var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapNodataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2747_11985",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2747_11985)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2747_11985",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H48V48H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2747_11985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2413 27.7382L33.52 23.6169C34.7001 21.4326 35.3231 18.9614 35.3231 16.4692C35.3231 8.16732 28.5686 1.41282 20.2667 1.41282C11.9647 1.41282 5.21027 8.16732 5.21027 16.4693C5.21027 18.9615 5.83333 21.4326 7.01786 23.6243L19.4433 46.0969C19.6087 46.3964 19.924 46.582 20.2667 46.582C20.6095 46.582 20.9246 46.3964 21.09 46.0969L24.3261 40.2443",
    stroke: "#343434",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3874 16.2777C26.3874 19.658 23.6471 22.3984 20.2667 22.3984C16.8863 22.3984 14.146 19.658 14.146 16.2777C14.146 12.8973 16.8863 10.1569 20.2667 10.1569C23.6471 10.1569 26.3874 12.8973 26.3874 16.2777Z",
    stroke: "#343434",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8593 37.0531C42.8593 42.3223 38.5877 46.5938 33.3186 46.5938C28.0495 46.5938 23.778 42.3223 23.778 37.0531C23.778 31.784 28.0495 27.5124 33.3186 27.5124C38.5877 27.5124 42.8593 31.784 42.8593 37.0531Z",
    stroke: "#343434",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3546 32.5078L33.3546 38.3398",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3546 41.3867V41.6003",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapNodataIcon);
export default __webpack_public_path__ + "static/media/MapNodataIcon.04fe39a7402c2f804a4809a0df6327b2.svg";
export { ForwardRef as ReactComponent };